export const FAQS_POOL_RESURFACING_VS_REMODELING = [
  {
    question: "Is pool resurfacing considered remodeling?",
    answer:
      "Pool resurfacing can be one component of a remodel. A resurfacing-only project is narrower because it focuses primarily on renewing the interior finish, while remodeling may include other pool and outdoor components.",
  },
  {
    question: "Can you remodel a pool without resurfacing it?",
    answer:
      "Potentially. If the planned work affects tile, coping, decking, pavers, or other components and the existing interior finish is still serviceable, resurfacing may not be necessary. The components and construction sequence should be evaluated together.",
  },
  {
    question: "Will resurfacing fix a leaking pool?",
    answer:
      "Not necessarily. Water loss can have several causes, including conditions unrelated to the interior finish. The source should be evaluated before assuming resurfacing will correct it.",
  },
  {
    question: "Should pool tile and coping be replaced during resurfacing?",
    answer:
      "Not automatically. Their condition, compatibility with the new finish, design goals, and the way the components meet should determine whether coordinated replacement makes sense.",
  },
  {
    question:
      "What is the difference between pool renovation and pool remodeling?",
    answer:
      "Contractors and homeowners often use renovation and remodeling interchangeably. The written scope matters more than the label. It should specify which surfaces, components, repairs, and upgrades are included.",
  },
  {
    question: "How can I tell whether pool cracks are cosmetic or structural?",
    answer:
      "A generic checklist cannot reliably determine the cause. Cracks, movement, or water loss should be professionally evaluated before the project scope is selected.",
  },
];

export const TOC_POOL_RESURFACING_VS_REMODELING = [
  { id: "what-is-pool-resurfacing", title: "What Is Pool Resurfacing?" },
  { id: "what-is-pool-remodeling", title: "What Is Pool Remodeling?" },
  { id: "at-a-glance", title: "Pool Resurfacing vs. Remodeling at a Glance" },
  {
    id: "finish-components-function-check",
    title: "The Finish–Components–Function Check",
  },
  {
    id: "when-resurfacing-may-be-enough",
    title: "When Resurfacing May Be Enough",
  },
  {
    id: "when-a-broader-pool-remodel-makes-sense",
    title: "When a Broader Pool Remodel May Make More Sense",
  },
  {
    id: "problems-evaluated-before-choosing",
    title: "Problems That Should Be Evaluated Before Choosing Either Option",
  },
  {
    id: "should-tile-coping-decking-be-updated",
    title: "Should Tile, Coping, and Decking Be Updated at the Same Time?",
  },
  {
    id: "how-to-prepare-for-pool-assessment",
    title: "How to Prepare for a Pool Assessment",
  },
  {
    id: "choosing-right-scope-south-florida",
    title: "Choosing the Right Scope for a South Florida Pool",
  },
  { id: "frequently-asked-questions", title: "Frequently Asked Questions" },
];
